import { render } from "./BlogDailyImplantsCare.vue?vue&type=template&id=53481e59"
import script from "./BlogDailyImplantsCare.vue?vue&type=script&lang=js"
export * from "./BlogDailyImplantsCare.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__